export default __webpack_public_path__ + "static/media/about-us.5054c53a.png";